import React from 'react'

export const Mail = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1892" height="1892" viewBox="0 0 1892 1892">
        <defs>
            <clipPath id="clip-Prancheta_7">
            <rect width="1892" height="1892"/>
            </clipPath>
        </defs>
        <g id="Prancheta_7" data-name="Prancheta – 7" clipPath="url(#clip-Prancheta_7)">
            <g id="noun_Mail_3181492" transform="translate(199.711 282)">
            <path id="Caminho_94" data-name="Caminho 94" d="M34.621,116.73,529.45,391.513a55.154,55.154,0,0,0,53.363,0L1077.2,116.73c63.64-35.282,10.167-131.346-53.363-96.064L556.1,280.556,87.928,20.611C24.344-14.561-28.964,81.393,34.621,116.73Z" transform="translate(190.841 431.007)" fill="#4605ff"/>
            <path id="Caminho_95" data-name="Caminho 95" d="M167.87,1324H1266.4c90.9,0,164.87-73.972,164.87-164.87V457.553A164.032,164.032,0,0,0,1340.15,310.1L742,10.811a54.941,54.941,0,0,0-49.186,0l-598.7,299.4A163.971,163.971,0,0,0,3,457.663V1159.13C3,1250.028,76.972,1324,167.87,1324ZM112.913,457.663A54.614,54.614,0,0,1,143.3,408.532L717.436,121.439l573.583,286.984a54.614,54.614,0,0,1,30.391,49.131V1159.13a55.012,55.012,0,0,1-54.957,54.957H167.87a55.012,55.012,0,0,1-54.957-54.957Z" transform="translate(29.289 0)" fill="#4605ff"/>
            </g>
        </g>
    </svg>
)